<!--
 * @Author: gongzhichao
 * @Date: 2023-05-10 17:33:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 列表公共页面
-->
<template>
  <div class="main">
    <SecondPage>
      <!-- <div class='list-content'>
        <div class='list-item animated' v-for='item in list' :key='item.date' @click='redirectPage(item)'>{{ item.postTitle }}</div>
      </div>-->
      <div class="tab-buttons">
        <button 
          v-for="btn in  $config.dataInfoList" 
          :key="btn.selectType" 
          @click="toggleTab(btn.selectType)" 
          :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
        >
            <div  :class="'tab-title'+ btn.tab">{{ btn.title }}</div>
                <img
                  :src="btn.backgroundImg"
                  alt=""
                  :class="'people-tab' + btn.tab"
                />
        </button>
      </div>
      <div class="announcement-content" v-if="currentTab === 'official' ">
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="getNewsOftype">
            <el-tab-pane label="最新" name="最新"></el-tab-pane>
            <el-tab-pane label="公告" name="0"></el-tab-pane>
            <el-tab-pane label="活动" name="2"></el-tab-pane>
            <el-tab-pane label="攻略" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list" v-loading="loading">
          <div
            class="list-item"
            v-for="item in newList.slice(0, 15)"
            :key="item.id"
          >
            <div class="info">
              <img
                src="../../../assets/image/pc/list-icon.png"
                alt="公告图标"
              />
              <a @click="redirectPage({ path: title, ...item })">{{
                item.title
              }}</a>
              <!-- <a>{{ item.title }}</a> -->
            </div>
            <div class="date">
              {{ $moment(item.createTime).format("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <div class="mypagination">
          <el-pagination
            hide-on-single-page
            background
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="15"
            :total="pageTotel"
            layout="total, prev, pager, next"
          ></el-pagination>
        </div>
      </div>

      <div class="announcement-content" v-if="currentTab === 'highExplosive' ">
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="getNewsOftype">
            <el-tab-pane label="最新" name="最新"></el-tab-pane>
            <el-tab-pane label="公告" name="0"></el-tab-pane>
            <el-tab-pane label="活动" name="2"></el-tab-pane>
            <el-tab-pane label="攻略" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list" v-loading="loading">
          <div
            class="list-item"
            v-for="item in newList.slice(0, 15)"
            :key="item.id"
          >
            <div class="info">
              <img
                src="../../../assets/image/pc/list-icon.png"
                alt="公告图标"
              />
              <a @click="redirectPage({ path: title, ...item })">{{
                item.title
              }}</a>
              <!-- <a>{{ item.title }}</a> -->
            </div>
            <div class="date">
              {{ $moment(item.createTime).format("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <div class="mypagination">
          <el-pagination
            hide-on-single-page
            background
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="15"
            :total="pageTotel"
            layout="total, prev, pager, next"
          ></el-pagination>
        </div>
      </div>

      <div class="announcement-content" v-if="currentTab === 'threeExplosive' ">
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="getNewsOftype">
            <el-tab-pane label="最新" name="最新"></el-tab-pane>
            <el-tab-pane label="公告" name="0"></el-tab-pane>
            <el-tab-pane label="活动" name="2"></el-tab-pane>
            <el-tab-pane label="攻略" name="1"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="list" v-loading="loading">
          <div
            class="list-item"
            v-for="item in newList.slice(0, 15)"
            :key="item.id"
          >
            <div class="info">
              <img
                src="../../../assets/image/pc/list-icon.png"
                alt="公告图标"
              />
              <a @click="redirectPage({ path: title, ...item })">{{
                item.title
              }}</a>
              <!-- <a>{{ item.title }}</a> -->
            </div>
            <div class="date">
              {{ $moment(item.createTime).format("YYYY-MM-DD") }}
            </div>
          </div>
        </div>
        <div class="mypagination">
          <el-pagination
            hide-on-single-page
            background
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :page-size="15"
            :total="pageTotel"
            layout="total, prev, pager, next"
          ></el-pagination>
        </div>
      </div>
    </SecondPage>
    <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
  </div>
</template>

<script>

import SecondPage from "../component/SecondPage/SecondPage.vue";
import webSiteHigh from "../../../api/webSiteHigh";
import webSite from "../../../api/webSite";
import webSiteThree from "../../../api/webSiteThree";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },
  components: { SecondPage },
  computed: {
    // 列表
  },
  data() {
    return {
      loading: false,
      showVisible:false,
      pageTotel: 0,
      currentPage: 1,
      activeName: "最新",
      newList: [],
      newListPro: [],
       currentTab: '',
    };
  },
  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },

  mounted() {
    this.getNewsOftype({ label: "最新" });
    this.toggleTab();
  },
  methods: {
      // 切换标签
    toggleTab(tab) {
      this.getNewsOftype({ label: "最新" });
      this.activeName="最新"
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');

      if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
        this.getNewsOftype({ label: "最新" });
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
        this.getNewsOftype({ label: "最新" });
      } else {
         this.currentTab="official"
         this.getNewsOftype({ label: "最新" });
        // 其他 tab 的处理逻辑
      }
    },
    // 页面跳转
    async redirectPage(item) {
      let { id, title } = item;
      this.$router.push({
        path: "/detail",
        query: { id, title, path: "公告" },
      });
    },

    // 获取文章
    async   getNewsOftype(tab) {
      const storedValue = sessionStorage.getItem('toggleTab');
      if(storedValue === 'threeExplosive'){
        let arr = [];
      const type = tab.name;
      switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteThree.getAllNews(newsType);
                arr=res.data ;
                break;
              }
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteThree.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;

      }else if(storedValue === 'highExplosive'){
        let arr = [];
      const type = tab.name;
      switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteHigh.getAllNews(newsType);
                arr=res.data ;
                break;
              }
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteHigh.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;

      }else{
        let arr = [];
       const type = tab.name;
       switch (tab.label) {
        case "最新":{
              let newsType = "0,1,2";
                let res = await webSite.getAllNews(newsType);
                arr=res.data ;
                break;
              }
          default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSite.getAllNews(newsType);
                arr =res.data ;
                break;
              }
      }
      this.currentPage = 1;
      this.newList = arr;
      this.newListPro = JSON.parse(JSON.stringify(arr));
      this.pageTotel = arr.length;
      }

    },

    // 分页
    handleCurrentChange(val) {
      this.loading = true;
      setTimeout(() => {
        this.newList = this.newListPro.slice((val - 1) * 15, val * 15);
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
       .tab-buttons {
  display: flex;
  gap:30px; /* 按钮之间的间距 */
  justify-content: center; /* 按钮居中显示 */
}

.tab-button {
  /* 基础按钮样式，确保文字居中 */
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #704c13;
  padding: 20px 40px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;
  outline: none;
  
  /* 移除默认按钮样式 */
  &:focus {
    outline: none;
  }
}

// 默认状态样式
.item-def {
  background-image: url("../../../assets/image/pc/basemap-data-def.png");
  /* 根据实际图片尺寸调整按钮大小 */
  width: 345px;
  height: 140px;

}

// 激活状态样式
.item-active {
  background-image: url("../../../assets/image/pc/basemap-data-active.png");
  color: #f4f7f6; /* 激活状态文字颜色 */

  width:345px;
  height: 140px;
}   
.tab-title1{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
.tab-title2{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
.tab-title3{
  width: 100%;
  font-size: 28px;
  text-align: center;
}
 .people-tab1 {
      width: 167px;
      height:197px;
      position: absolute;
      margin-left: -12%;
      margin-top: -8%;
  }
  .people-tab2 {
       width: 180px;
       height: 197px;
       position: absolute;
      // margin-right: -9%;
      margin-top: -8%;
      margin-left: 2%;
  }
 .people-tab3 {
      width: 167px;
      height:197px;
      position: absolute;
      margin-left: -12%;
      margin-top: -8%;
  }
.list-content {
  /*base code*/
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .animated.infinite {
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }
  .animated.hinge {
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
  }
  /*the animation definition*/
  @-webkit-keyframes bounce {
    0%,
    100%,
    20%,
    53%,
    80% {
      -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    40%,
    43% {
      -webkit-transition-timing-function: cubic-bezier(
        0.755,
        0.05,
        0.855,
        0.06
      );
      transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -30px, 0);
      transform: translate3d(0, -30px, 0);
    }
    70% {
      -webkit-transition-timing-function: cubic-bezier(
        0.755,
        0.05,
        0.855,
        0.06
      );
      transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -15px, 0);
      transform: translate3d(0, -15px, 0);
    }
    90% {
      -webkit-transform: translate3d(0, -4px, 0);
      transform: translate3d(0, -4px, 0);
    }
  }
  @keyframes bounce {
    0%,
    100%,
    20%,
    53%,
    80% {
      -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      -webkit-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    40%,
    43% {
      -webkit-transition-timing-function: cubic-bezier(
        0.755,
        0.05,
        0.855,
        0.06
      );
      transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -30px, 0);
      -ms-transform: translate3d(0, -30px, 0);
      transform: translate3d(0, -30px, 0);
    }
    70% {
      -webkit-transition-timing-function: cubic-bezier(
        0.755,
        0.05,
        0.855,
        0.06
      );
      transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
      -webkit-transform: translate3d(0, -15px, 0);
      -ms-transform: translate3d(0, -15px, 0);
      transform: translate3d(0, -15px, 0);
    }
    90% {
      -webkit-transform: translate3d(0, -4px, 0);
      -ms-transform: translate3d(0, -4px, 0);
      transform: translate3d(0, -4px, 0);
    }
  }
  /*base code*/
  .animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .animated.infinite {
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
  }
  .animated.hinge {
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
  }
  /*the animation definition*/
  @-webkit-keyframes shake {
    0%,
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }
    20%,
    40%,
    60%,
    80% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }
  @keyframes shake {
    0%,
    100% {
      -webkit-transform: translate3d(0, 0, 0);
      -ms-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
      -webkit-transform: translate3d(-10px, 0, 0);
      -ms-transform: translate3d(-10px, 0, 0);
      transform: translate3d(-10px, 0, 0);
    }
    20%,
    40%,
    60%,
    80% {
      -webkit-transform: translate3d(10px, 0, 0);
      -ms-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }
  }
  .shake {
    -webkit-animation-name: shake;
    animation-name: shake;
  }

  .list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 50px;
    line-height: 50px;
    margin: 2px 0;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
  .list-item:hover {
    -webkit-animation-name: shake;
    animation-name: shake;
  }
}

.announcement-content {
  display: flex;
  flex-direction: column;
  .tab {
    display: flex;
    width: 100%;
    height: 50px;

    /deep/ .el-tabs__header {
      height: 50px;
      margin: 0;
      margin-left: 15px;
    }
    /deep/.el-tabs__nav-scroll {
      height: 50px;
    }

    /deep/ .el-tabs__nav {
      height: 50px;
    }

    /deep/ .el-tabs__item {
      height: 50px;
      line-height: 50px;
      font-size: 20px;
    }
    /deep/.el-tabs__active-bar {
      background-color: #745934;
    }
    /deep/ .el-tabs__item:hover {
      color: #ff913d;
    }
    /deep/ .el-tabs__item.is-active {
      color: #ff913d;
    }

    p {
      width: 67px;
      height: 50px;
      text-align: center;
      line-height: 50px;
    }
  }
  .list {
    margin-top: 20px;
    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
      cursor: pointer;
      .info {
        flex: 4;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        img {
          margin-right: 5px;
        }
      }
      .date {
        flex: 1;
        color: #999;
      }
    }
  }
  .mypagination {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    /deep/ .el-pagination button {
      width: 30px;
      height: 30px;
    }
    /deep/ .el-pagination span {
      // width: 30px;
      height: 30px;
      font-size: 24px;
      line-height: 30px;
    }

    /deep/ .el-pagination .el-pager li {
      width: 30px;
      height: 30px;
      line-height: 30px;
    }

    /deep/ .el-pagination button:disabled {
      background: transparent;
      background-color: #e5e1d9;
      span {
        // font-size: 20px;
        color: #643e22;
        font-weight: 700;
      }
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #e8ce98;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
      background-color: #e5e1d9;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #643e22;
    }
  }
}
</style>
